module.exports = __webpack_public_path__ + "static/media/maroof2.7c60f983.jpg";